import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.CIconButton,
    style: {
      '--icon-size': "".concat(_vm.iconSize, "px")
    }
  }, [_c('STextButton', {
    class: _vm.$style.button,
    attrs: {
      "framing": "",
      "theme": "inherit",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    },
    scopedSlots: _vm._u([{
      key: _vm.slotName,
      fn: function fn() {
        return [_vm._t("icon", function () {
          return [_c('SIcon', {
            attrs: {
              "icon": _vm.icon,
              "size": _vm.iconSize
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  }, [_c('span', {
    class: [_vm.$style.text, _defineProperty({}, _vm.$style.hideTextOnMobile, _vm.hideTextOnMobile)]
  }, [_vm._t("default", function () {
    return [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")];
  })], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };